module.exports = __webpack_public_path__ + "img/share-cashback.6501e4b6.gif";